import React, { useState } from "react";

export default function UISandbox() {
  const [showModal, setShowModal] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [selectedTab, setSelectedTab] = useState("tab1");

  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-50 via-white to-purple-50 px-4 py-8">
      <div className="max-w-7xl mx-auto space-y-8">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-900">
            UI Component Sandbox
          </h1>
          <p className="mt-2 text-gray-600">
            Alle Komponenten für das LinkyShorty Projekt
          </p>
        </div>

        {/* === BUTTONS === */}
        <section className="bg-white rounded-2xl shadow-lg ring-1 ring-gray-200 p-8">
          <h2 className="text-2xl font-bold text-gray-900 mb-6">Buttons</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {/* Primary Gradient */}
            <button className="px-6 py-3 rounded-xl bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 text-white font-medium transition-all duration-200">
              Primary Gradient
            </button>

            {/* Primary Solid */}
            <button className="px-6 py-3 rounded-xl bg-blue-600 hover:bg-blue-700 text-white font-medium transition-colors">
              Primary Solid
            </button>

            {/* Secondary */}
            <button className="px-6 py-3 rounded-xl bg-gray-900 hover:bg-black text-white font-medium transition-colors">
              Secondary
            </button>

            {/* Outline */}
            <button className="px-6 py-3 rounded-xl border-2 border-blue-600 text-blue-600 hover:bg-blue-50 font-medium transition-colors">
              Outline
            </button>

            {/* Ghost */}
            <button className="px-6 py-3 rounded-xl text-gray-700 hover:bg-gray-100 font-medium transition-colors">
              Ghost
            </button>

            {/* Disabled */}
            <button
              className="px-6 py-3 rounded-xl bg-gray-300 text-gray-500 cursor-not-allowed font-medium"
              disabled
            >
              Disabled
            </button>

            {/* Icon Button */}
            <button className="px-6 py-3 rounded-xl bg-green-600 hover:bg-green-700 text-white font-medium transition-colors flex items-center justify-center gap-2">
              <svg
                className="w-5 h-5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M5 13l4 4L19 7"
                />
              </svg>
              Success
            </button>

            {/* Danger */}
            <button className="px-6 py-3 rounded-xl bg-red-600 hover:bg-red-700 text-white font-medium transition-colors">
              Danger
            </button>

            {/* Small Button */}
            <button className="px-4 py-2 text-sm rounded-lg bg-blue-600 hover:bg-blue-700 text-white font-medium transition-colors">
              Small Button
            </button>
          </div>
        </section>

        {/* === INPUTS === */}
        <section className="bg-white rounded-2xl shadow-lg ring-1 ring-gray-200 p-8">
          <h2 className="text-2xl font-bold text-gray-900 mb-6">
            Input Fields
          </h2>
          <div className="space-y-4">
            {/* Standard Input */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Standard Input
              </label>
              <input
                type="text"
                placeholder="Gib etwas ein..."
                className="w-full rounded-xl border border-gray-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 outline-none px-4 py-3 text-gray-900 placeholder:text-gray-400"
              />
            </div>

            {/* URL Input */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                URL Input
              </label>
              <input
                type="url"
                placeholder="https://www.example.com"
                className="w-full rounded-xl border border-gray-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 outline-none px-4 py-3 text-gray-900 placeholder:text-gray-400"
              />
            </div>

            {/* Input with Icon */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Search Input
              </label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <svg
                    className="h-5 w-5 text-gray-400"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                    />
                  </svg>
                </div>
                <input
                  type="text"
                  placeholder="Suche..."
                  className="w-full pl-10 rounded-xl border border-gray-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 outline-none px-4 py-3 text-gray-900 placeholder:text-gray-400"
                />
              </div>
            </div>

            {/* Textarea */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Textarea
              </label>
              <textarea
                rows={4}
                placeholder="Mehrzeiliger Text..."
                className="w-full rounded-xl border border-gray-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 outline-none px-4 py-3 text-gray-900 placeholder:text-gray-400 resize-none"
              />
            </div>

            {/* Select */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Select
              </label>
              <select className="w-full rounded-xl border border-gray-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 outline-none px-4 py-3 text-gray-900">
                <option>Option 1</option>
                <option>Option 2</option>
                <option>Option 3</option>
              </select>
            </div>
          </div>
        </section>

        {/* === CARDS === */}
        <section className="bg-white rounded-2xl shadow-lg ring-1 ring-gray-200 p-8">
          <h2 className="text-2xl font-bold text-gray-900 mb-6">Cards</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {/* Simple Card */}
            <div className="bg-white rounded-xl shadow-md border border-gray-200 p-6">
              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                Simple Card
              </h3>
              <p className="text-gray-600 text-sm">
                Eine einfache Karte mit Titel und Text.
              </p>
            </div>

            {/* Card with Icon */}
            <div className="bg-gradient-to-br from-blue-50 to-purple-50 rounded-xl shadow-md border border-blue-200 p-6">
              <div className="w-12 h-12 bg-gradient-to-br from-blue-600 to-purple-600 rounded-lg flex items-center justify-center mb-4">
                <svg
                  className="w-6 h-6 text-white"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"
                  />
                </svg>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                Icon Card
              </h3>
              <p className="text-gray-600 text-sm">
                Karte mit Icon und Gradient Hintergrund.
              </p>
            </div>

            {/* Stat Card */}
            <div className="bg-white rounded-xl shadow-md border border-gray-200 p-6">
              <p className="text-sm text-gray-600 mb-1">Total Clicks</p>
              <p className="text-3xl font-bold text-gray-900 mb-2">1,234</p>
              <p className="text-sm text-green-600 flex items-center gap-1">
                <svg
                  className="w-4 h-4"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M5 10l7-7m0 0l7 7m-7-7v18"
                  />
                </svg>
                +12% from last week
              </p>
            </div>
          </div>
        </section>

        {/* === BADGES & PILLS === */}
        <section className="bg-white rounded-2xl shadow-lg ring-1 ring-gray-200 p-8">
          <h2 className="text-2xl font-bold text-gray-900 mb-6">
            Badges & Pills
          </h2>
          <div className="flex flex-wrap gap-3">
            <span className="px-3 py-1 rounded-full bg-blue-100 text-blue-800 text-sm font-medium">
              Blue
            </span>
            <span className="px-3 py-1 rounded-full bg-green-100 text-green-800 text-sm font-medium">
              Active
            </span>
            <span className="px-3 py-1 rounded-full bg-red-100 text-red-800 text-sm font-medium">
              Inactive
            </span>
            <span className="px-3 py-1 rounded-full bg-purple-100 text-purple-800 text-sm font-medium">
              Premium
            </span>
            <span className="px-3 py-1 rounded-full bg-yellow-100 text-yellow-800 text-sm font-medium">
              Pending
            </span>
            <span className="px-3 py-1 rounded-full bg-gray-100 text-gray-800 text-sm font-medium">
              Default
            </span>
            <span className="px-3 py-1 rounded-md bg-gradient-to-r from-blue-600 to-purple-600 text-white text-sm font-medium">
              Gradient
            </span>
          </div>
        </section>

        {/* === ALERTS === */}
        <section className="bg-white rounded-2xl shadow-lg ring-1 ring-gray-200 p-8">
          <h2 className="text-2xl font-bold text-gray-900 mb-6">
            Alerts & Notifications
          </h2>
          <div className="space-y-4">
            {/* Success Alert */}
            <div className="rounded-xl bg-green-50 border border-green-200 p-4 flex items-start gap-3">
              <svg
                className="w-5 h-5 text-green-600 mt-0.5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M5 13l4 4L19 7"
                />
              </svg>
              <div className="flex-1">
                <h4 className="font-semibold text-green-900">Success!</h4>
                <p className="text-sm text-green-700 mt-1">
                  Your link has been successfully shortened.
                </p>
              </div>
            </div>

            {/* Error Alert */}
            <div className="rounded-xl bg-red-50 border border-red-200 p-4 flex items-start gap-3">
              <svg
                className="w-5 h-5 text-red-600 mt-0.5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
              <div className="flex-1">
                <h4 className="font-semibold text-red-900">Error!</h4>
                <p className="text-sm text-red-700 mt-1">
                  Something went wrong. Please try again.
                </p>
              </div>
            </div>

            {/* Warning Alert */}
            <div className="rounded-xl bg-yellow-50 border border-yellow-200 p-4 flex items-start gap-3">
              <svg
                className="w-5 h-5 text-yellow-600 mt-0.5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                />
              </svg>
              <div className="flex-1">
                <h4 className="font-semibold text-yellow-900">Warning!</h4>
                <p className="text-sm text-yellow-700 mt-1">
                  This action cannot be undone.
                </p>
              </div>
            </div>

            {/* Info Alert */}
            <div className="rounded-xl bg-blue-50 border border-blue-200 p-4 flex items-start gap-3">
              <svg
                className="w-5 h-5 text-blue-600 mt-0.5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
              <div className="flex-1">
                <h4 className="font-semibold text-blue-900">Info</h4>
                <p className="text-sm text-blue-700 mt-1">
                  Your account has been upgraded to premium.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* === LINK LIST === */}
        <section className="bg-white rounded-2xl shadow-lg ring-1 ring-gray-200 p-8">
          <h2 className="text-2xl font-bold text-gray-900 mb-6">
            Link List / URL Cards
          </h2>
          <div className="space-y-3">
            {/* Link Item 1 */}
            <div className="flex items-center justify-between p-4 bg-gray-50 rounded-xl hover:bg-gray-100 transition-colors">
              <div className="flex-1 min-w-0">
                <div className="font-semibold text-gray-900 mb-1">
                  linky.sh/abc123
                </div>
                <div className="text-sm text-gray-500 truncate">
                  https://www.example.com/very-long-url
                </div>
              </div>
              <div className="flex items-center gap-3 ml-4">
                <div className="text-right">
                  <div className="text-2xl font-bold text-blue-600">42</div>
                  <div className="text-xs text-gray-500">Klicks</div>
                </div>
                <button className="p-3 hover:bg-gray-200 rounded-lg transition-colors h-12 w-12 flex items-center justify-center">
                  <svg
                    className="w-5 h-5 text-gray-400"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"
                    />
                  </svg>
                </button>
                <button className="p-3 hover:bg-gray-200 rounded-lg transition-colors h-12 w-12 flex items-center justify-center">
                  <svg
                    className="w-5 h-5 text-gray-400"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                    />
                  </svg>
                </button>
              </div>
            </div>

            {/* Link Item 2 - Active State */}
            <div className="flex items-center justify-between p-4 bg-blue-50 border-2 border-blue-200 rounded-xl">
              <div className="flex-1 min-w-0">
                <div className="font-semibold text-gray-900 mb-1 flex items-center gap-2">
                  linky.sh/gh456
                  <span className="px-2 py-0.5 rounded-full bg-green-100 text-green-800 text-xs font-medium">
                    Active
                  </span>
                </div>
                <div className="text-sm text-gray-500 truncate">
                  https://github.com/user/repository
                </div>
              </div>
              <div className="flex items-center gap-3 ml-4">
                <div className="text-right">
                  <div className="text-2xl font-bold text-blue-600">156</div>
                  <div className="text-xs text-gray-500">Klicks</div>
                </div>
                <button className="p-3 hover:bg-blue-100 rounded-lg transition-colors h-12 w-12 flex items-center justify-center">
                  <svg
                    className="w-5 h-5 text-gray-400"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"
                    />
                  </svg>
                </button>
                <button className="p-3 hover:bg-blue-100 rounded-lg transition-colors h-12 w-12 flex items-center justify-center">
                  <svg
                    className="w-5 h-5 text-gray-400"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </section>

        {/* === TABS === */}
        <section className="bg-white rounded-2xl shadow-lg ring-1 ring-gray-200 p-8">
          <h2 className="text-2xl font-bold text-gray-900 mb-6">Tabs</h2>
          <div className="border-b border-gray-200">
            <nav className="flex gap-6">
              <button
                onClick={() => setSelectedTab("tab1")}
                className={`pb-3 border-b-2 font-medium transition-colors ${
                  selectedTab === "tab1"
                    ? "border-blue-600 text-blue-600"
                    : "border-transparent text-gray-500 hover:text-gray-700"
                }`}
              >
                Overview
              </button>
              <button
                onClick={() => setSelectedTab("tab2")}
                className={`pb-3 border-b-2 font-medium transition-colors ${
                  selectedTab === "tab2"
                    ? "border-blue-600 text-blue-600"
                    : "border-transparent text-gray-500 hover:text-gray-700"
                }`}
              >
                Analytics
              </button>
              <button
                onClick={() => setSelectedTab("tab3")}
                className={`pb-3 border-b-2 font-medium transition-colors ${
                  selectedTab === "tab3"
                    ? "border-blue-600 text-blue-600"
                    : "border-transparent text-gray-500 hover:text-gray-700"
                }`}
              >
                Settings
              </button>
            </nav>
          </div>
          <div className="mt-6">
            {selectedTab === "tab1" && (
              <p className="text-gray-600">Overview Content</p>
            )}
            {selectedTab === "tab2" && (
              <p className="text-gray-600">Analytics Content</p>
            )}
            {selectedTab === "tab3" && (
              <p className="text-gray-600">Settings Content</p>
            )}
          </div>
        </section>

        {/* === LOADING STATES === */}
        <section className="bg-white rounded-2xl shadow-lg ring-1 ring-gray-200 p-8">
          <h2 className="text-2xl font-bold text-gray-900 mb-6">
            Loading States
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {/* Spinner */}
            <div className="flex flex-col items-center gap-3">
              <div className="w-12 h-12 border-4 border-blue-200 border-t-blue-600 rounded-full animate-spin"></div>
              <p className="text-sm text-gray-600">Spinner</p>
            </div>

            {/* Dots */}
            <div className="flex flex-col items-center gap-3">
              <div className="flex gap-2">
                <div
                  className="w-3 h-3 bg-blue-600 rounded-full animate-bounce"
                  style={{ animationDelay: "0ms" }}
                ></div>
                <div
                  className="w-3 h-3 bg-blue-600 rounded-full animate-bounce"
                  style={{ animationDelay: "150ms" }}
                ></div>
                <div
                  className="w-3 h-3 bg-blue-600 rounded-full animate-bounce"
                  style={{ animationDelay: "300ms" }}
                ></div>
              </div>
              <p className="text-sm text-gray-600">Dots</p>
            </div>

            {/* Pulse */}
            <div className="flex flex-col items-center gap-3">
              <div className="w-12 h-12 bg-blue-600 rounded-full animate-pulse"></div>
              <p className="text-sm text-gray-600">Pulse</p>
            </div>
          </div>
        </section>

        {/* === MODALS === */}
        <section className="bg-white rounded-2xl shadow-lg ring-1 ring-gray-200 p-8">
          <h2 className="text-2xl font-bold text-gray-900 mb-6">
            Modals & Dialogs
          </h2>
          <div className="flex gap-4">
            <button
              onClick={() => setShowModal(true)}
              className="px-6 py-3 rounded-xl bg-blue-600 hover:bg-blue-700 text-white font-medium transition-colors"
            >
              Open Modal
            </button>
            <button
              onClick={() => setShowToast(true)}
              className="px-6 py-3 rounded-xl bg-green-600 hover:bg-green-700 text-white font-medium transition-colors"
            >
              Show Toast
            </button>
          </div>
        </section>

        {/* === STATS GRID === */}
        <section className="bg-white rounded-2xl shadow-lg ring-1 ring-gray-200 p-8">
          <h2 className="text-2xl font-bold text-gray-900 mb-6">Stats Grid</h2>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
            <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl p-6">
              <p className="text-sm text-blue-700 font-medium mb-2">
                Total Links
              </p>
              <p className="text-3xl font-bold text-blue-900">1,234</p>
              <p className="text-xs text-blue-600 mt-2">
                +20.1% from last month
              </p>
            </div>
            <div className="bg-gradient-to-br from-green-50 to-green-100 rounded-xl p-6">
              <p className="text-sm text-green-700 font-medium mb-2">
                Total Clicks
              </p>
              <p className="text-3xl font-bold text-green-900">45.2K</p>
              <p className="text-xs text-green-600 mt-2">
                +180.1% from last month
              </p>
            </div>
            <div className="bg-gradient-to-br from-purple-50 to-purple-100 rounded-xl p-6">
              <p className="text-sm text-purple-700 font-medium mb-2">
                Avg. CTR
              </p>
              <p className="text-3xl font-bold text-purple-900">3.65%</p>
              <p className="text-xs text-purple-600 mt-2">
                +4.75% from last month
              </p>
            </div>
            <div className="bg-gradient-to-br from-orange-50 to-orange-100 rounded-xl p-6">
              <p className="text-sm text-orange-700 font-medium mb-2">
                Active Users
              </p>
              <p className="text-3xl font-bold text-orange-900">573</p>
              <p className="text-xs text-orange-600 mt-2">
                +12% from last month
              </p>
            </div>
          </div>
        </section>

        {/* === CHECKBOXES & RADIOS === */}
        <section className="bg-white rounded-2xl shadow-lg ring-1 ring-gray-200 p-8">
          <h2 className="text-2xl font-bold text-gray-900 mb-6">
            Checkboxes & Radios
          </h2>
          <div className="space-y-4">
            <label className="flex items-center gap-3 cursor-pointer">
              <input
                type="checkbox"
                className="w-5 h-5 rounded border-gray-300 text-blue-600 focus:ring-2 focus:ring-blue-200"
              />
              <span className="text-gray-700">Enable notifications</span>
            </label>
            <label className="flex items-center gap-3 cursor-pointer">
              <input
                type="checkbox"
                className="w-5 h-5 rounded border-gray-300 text-blue-600 focus:ring-2 focus:ring-blue-200"
                defaultChecked
              />
              <span className="text-gray-700">Auto-shorten links</span>
            </label>
            <div className="pt-4 border-t border-gray-200">
              <p className="text-sm font-medium text-gray-700 mb-3">
                Select a plan:
              </p>
              <div className="space-y-3">
                <label className="flex items-center gap-3 cursor-pointer">
                  <input
                    type="radio"
                    name="plan"
                    className="w-5 h-5 border-gray-300 text-blue-600 focus:ring-2 focus:ring-blue-200"
                  />
                  <span className="text-gray-700">Free Plan</span>
                </label>
                <label className="flex items-center gap-3 cursor-pointer">
                  <input
                    type="radio"
                    name="plan"
                    className="w-5 h-5 border-gray-300 text-blue-600 focus:ring-2 focus:ring-blue-200"
                    defaultChecked
                  />
                  <span className="text-gray-700">Pro Plan</span>
                </label>
                <label className="flex items-center gap-3 cursor-pointer">
                  <input
                    type="radio"
                    name="plan"
                    className="w-5 h-5 border-gray-300 text-blue-600 focus:ring-2 focus:ring-blue-200"
                  />
                  <span className="text-gray-700">Enterprise Plan</span>
                </label>
              </div>
            </div>
          </div>
        </section>

        {/* === TOGGLES === */}
        <section className="bg-white rounded-2xl shadow-lg ring-1 ring-gray-200 p-8">
          <h2 className="text-2xl font-bold text-gray-900 mb-6">
            Toggle Switches
          </h2>
          <div className="space-y-4">
            <label className="flex items-center justify-between cursor-pointer">
              <span className="text-gray-700">Dark Mode</span>
              <div className="relative">
                <input
                  type="checkbox"
                  className="sr-only peer"
                />
                <div className="w-11 h-6 bg-gray-300 rounded-full peer peer-checked:bg-blue-600 peer-focus:ring-2 peer-focus:ring-blue-200 transition-colors"></div>
                <div className="absolute left-1 top-1 bg-white w-4 h-4 rounded-full transition-transform peer-checked:translate-x-5"></div>
              </div>
            </label>
            <label className="flex items-center justify-between cursor-pointer">
              <span className="text-gray-700">Email Notifications</span>
              <div className="relative">
                <input
                  type="checkbox"
                  className="sr-only peer"
                  defaultChecked
                />
                <div className="w-11 h-6 bg-gray-300 rounded-full peer peer-checked:bg-blue-600 peer-focus:ring-2 peer-focus:ring-blue-200 transition-colors"></div>
                <div className="absolute left-1 top-1 bg-white w-4 h-4 rounded-full transition-transform peer-checked:translate-x-5"></div>
              </div>
            </label>
          </div>
        </section>
      </div>

      {/* Modal */}
      {showModal && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50"
          onClick={() => setShowModal(false)}
        >
          <div
            className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-8"
            onClick={(e) => e.stopPropagation()}
          >
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              Modal Title
            </h3>
            <p className="text-gray-600 mb-6">
              Dies ist ein Beispiel-Modal. Hier können Bestätigungen, Formulare
              oder andere Inhalte angezeigt werden.
            </p>
            <div className="flex gap-3">
              <button
                onClick={() => setShowModal(false)}
                className="flex-1 px-4 py-2 rounded-xl border-2 border-gray-300 text-gray-700 hover:bg-gray-50 font-medium transition-colors"
              >
                Cancel
              </button>
              <button
                onClick={() => setShowModal(false)}
                className="flex-1 px-4 py-2 rounded-xl bg-blue-600 hover:bg-blue-700 text-white font-medium transition-colors"
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Toast */}
      {showToast && (
        <div className="fixed bottom-4 right-4 bg-green-600 text-white px-6 py-4 rounded-xl shadow-2xl flex items-center gap-3 z-50 animate-slide-up">
          <svg
            className="w-5 h-5"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M5 13l4 4L19 7"
            />
          </svg>
          <span className="font-medium">Operation successful!</span>
          <button
            onClick={() => setShowToast(false)}
            className="ml-4 hover:bg-green-700 rounded p-1"
          >
            <svg
              className="w-4 h-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>
      )}
    </div>
  );
}
